var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 21H23.5L12.5 2L1.5 21ZM13.5 18H11.5V16H13.5V18ZM13.5 14H11.5V10H13.5V14Z",
    fill: "#FFA000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadera);
export default __webpack_public_path__ + "static/media/radera.5b552e796518c09aa0a12e5aea3ec978.svg";
export { ForwardRef as ReactComponent };